export default __webpack_public_path__ + "static/media/skyline_salzburg_greyish_02_derived.03ea9fcf.svg";